import React from 'react';
import { Box, Typography } from '@mui/material';
import ScrollFadeWrapper, {
  ScrollFadeSection,
} from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import {
  SEO_SUBJECT_EXPLAINER_BLUE,
  SEO_SUBJECT_EXPLAINER_YELLOW,
  SeoSubjectExplainerCard,
} from './SeoSubjectExplainerShared';
import Image from '../../Image/Image';

const DEFAULT_ICON_SIZE = '120px';
const BLUE_PANEL_HEIGHT = 480;
const LAST_CARD_BLUE_EXTEND = 24;

const SeoSubjectExplainerComponent = ({ data }) => {
  if (!data) return null;

  const { title, description, icon, footer, cards = [] } = data;

  return (
    <ScrollFadeSection
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        boxSizing: 'border-box',
        px: { xs: '16px', md: '24px' },
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '1113px',
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-start',
          overflow: 'visible',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            position: 'sticky',
            top: '120px',
            flex: '0 0 803px',
            ml: '-30px',
            width: '803px',
            height: `${BLUE_PANEL_HEIGHT + LAST_CARD_BLUE_EXTEND}px`,
            backgroundColor: SEO_SUBJECT_EXPLAINER_BLUE,
            borderRadius: '34px',
            boxSizing: 'border-box',
            padding: '40px',
            gap: '32px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            zIndex: 1,
            flexShrink: 0,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: DEFAULT_ICON_SIZE,
              height: DEFAULT_ICON_SIZE,
              borderRadius: '28px',
              backgroundColor: SEO_SUBJECT_EXPLAINER_YELLOW,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: '0px',
              boxSizing: 'border-box',
              flexShrink: 0,
            }}
          >
            <Image
              width={72}
              height={72}
              src={icon}
              alt="icon graphic"
              aria-hidden="true"
              sx={{
                width: '72px',
                height: '72px',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </Box>

          <Box
            sx={{
              width: '475px',
              height: '248px',
              boxSizing: 'border-box',
              px: '40px',
              gap: '32px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 700,
                fontSize: '3rem',
                lineHeight: '3.25rem',
                letterSpacing: '-0.03em',
                color: '#FFFFFF',
                whiteSpace: 'pre-line',
                width: '100%',
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1.5rem',
                lineHeight: '1.75rem',
                letterSpacing: '-0.03em',
                color: '#FFFFFF',
                whiteSpace: 'pre-line',
                width: '100%',
              }}
            >
              {description}
            </Typography>
          </Box>

          {footer ? (
            <Typography
              sx={{
                mt: 'auto',
                pt: '0px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1rem',
                lineHeight: '1.5rem',
                letterSpacing: '-0.02em',
                color: 'rgba(255,255,255,0.88)',
                whiteSpace: 'pre-line',
                maxWidth: { xs: '100%', md: '560px' },
              }}
            >
              {footer}
            </Typography>
          ) : null}
        </Box>

        <Box
          sx={{
            width: '596px',
            flex: '0 0 596px',
            ml: '-286px',
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '24px', md: '40px' },
            pt: { xs: '40px', md: '64px' },
            pb: { xs: '16px', md: '64px' },
            position: 'relative',
            zIndex: 2,
          }}
        >
          {cards.map((card, index) => {
            return (
              <ScrollFadeWrapper
                key={card?.title || index}
                delay={index * 0.12}
                variant="text"
                sx={{
                  width: '100%',
                }}
              >
                <SeoSubjectExplainerCard card={card} index={index} isDesktop />
              </ScrollFadeWrapper>
            );
          })}
        </Box>
      </Box>
    </ScrollFadeSection>
  );
};

export default SeoSubjectExplainerComponent;
